/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Before_Unload_ConfirmInputs */

const en_creator_before_unload_confirm = /** @type {(inputs: Creator_Before_Unload_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to leave?`)
};

const fr_creator_before_unload_confirm = /** @type {(inputs: Creator_Before_Unload_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etes-vous sur de vouloir quitter ?`)
};

const de_creator_before_unload_confirm = /** @type {(inputs: Creator_Before_Unload_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bist du sicher, dass du gehen willst?`)
};

const it_creator_before_unload_confirm = /** @type {(inputs: Creator_Before_Unload_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sei sicuro di voler uscire?`)
};

const ru_creator_before_unload_confirm = /** @type {(inputs: Creator_Before_Unload_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы уверены, что хотите уйти?`)
};

const es_creator_before_unload_confirm = /** @type {(inputs: Creator_Before_Unload_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Estás seguro que deseas salir?`)
};

const zh_cn2_creator_before_unload_confirm = /** @type {(inputs: Creator_Before_Unload_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你确定要离开吗？`)
};

const ja_creator_before_unload_confirm = /** @type {(inputs: Creator_Before_Unload_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本当に退出しますか?`)
};

const hi_creator_before_unload_confirm = /** @type {(inputs: Creator_Before_Unload_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या आपकी वाकई छोड़ने की इच्छा है?`)
};

const pt_pt2_creator_before_unload_confirm = /** @type {(inputs: Creator_Before_Unload_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tem certeza de que deseja ir embora?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to leave?" |
*
* @param {Creator_Before_Unload_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_before_unload_confirm = /** @type {((inputs?: Creator_Before_Unload_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Before_Unload_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_creator_before_unload_confirm(inputs)
	if (locale === "de") return de_creator_before_unload_confirm(inputs)
	if (locale === "it") return it_creator_before_unload_confirm(inputs)
	if (locale === "ru") return ru_creator_before_unload_confirm(inputs)
	if (locale === "es") return es_creator_before_unload_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_creator_before_unload_confirm(inputs)
	if (locale === "ja") return ja_creator_before_unload_confirm(inputs)
	if (locale === "hi") return hi_creator_before_unload_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_creator_before_unload_confirm(inputs)
	return en_creator_before_unload_confirm(inputs)
});